import Icon from '../components/Icon.vue'

Icon.register({
  joint: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M444.3 181.1C466.7 196.8 480 222.3 480 249.7V280C480 284.4 483.6 288 488 288H536C540.4 288 544 284.4 544 280V249.7C544 206.4 523 166.3 487.7 141.6 463.9 125 448 99.3 448 70.3V8C448 3.6 444.4 0 440 0H392C387.6 0 384 3.6 384 8V74.4C384 118.1 408.6 156 444.3 181.1zM195 359C126 370.1 59.7 394.7 0 432 83.7 484.3 180.3 512 278.9 512H367.5L254.8 380.5C240.1 363.3 217.3 355.4 195 359zM553.3 87.1C547.6 83.3 544 77.1 544 70.3V8C544 3.6 540.4 0 536 0H488C483.6 0 480 3.6 480 8V70.3C480 92.3 490.2 113.7 508.6 125.7 550.8 153 576 199.5 576 249.7V280C576 284.4 579.6 288 584 288H632C636.4 288 640 284.4 640 280V249.7C640 184.3 607.6 123.5 553.3 87.1zM360.9 352.1C326.5 352.1 274.1 352.2 272.7 352.2L390.5 489.6A64-64 0 0 1 439.1 512H527.5L409.6 374.4A64-64 0 0 1 360.9 352zM616 352H432L550 489.6A64-64 0 0 1 598.6 512H616C629.3 512 640 501.3 640 488V376C640 362.7 629.3 352 616 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/joint.js
// module id = IFCh
// module chunks = 144